import React from 'react';
import { useDrag } from 'react-dnd';
import GetPieceConfig from '../../utils/GetPieceConfig';
import temVirgula from '../../utils/temVirgula';

// Tipos de peça
const ItemTypes = {
    PIECE: 'piece',
  };
  
  // Component que representa as peças da sidebar
export default function Piece ({ size, type, cellInfo, onPieceClick }) {
      const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.PIECE,
        item: { size, type, cellInfo }, // aqui infos passadas para obj no mapa
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
      }));
    
      const pieceConfig = GetPieceConfig(size);
    
      // Define o estilo com base na configuração da peça
      let style = {}
  
      if(type == 'rack') {
        // estilo dos racks a partir de status1 = added/churned | true/false e status2 = reserver | true/false
        if(temVirgula(cellInfo.label)){
          style = {
            opacity: isDragging ? 0.5 : 1,
            width: pieceConfig.width,
            height: pieceConfig.height,
            marginBottom: '10px',
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: pieceConfig.border,
            background:  cellInfo.status2 ? 'linear-gradient(45deg, #E89F1750 50%, #71CACD 50%)' : cellInfo.status1 ? 'linear-gradient(45deg, rgba(183, 61, 61, 0.30) 70%, #71CACD 30%)' : 'linear-gradient(45deg, rgba(89, 151, 92, 0.30) 50%, #71CACD 50%)',
          };
        } else {
          style = {
            opacity: isDragging ? 0.5 : 1,
            width: pieceConfig.width,
            height: pieceConfig.height,
            marginBottom: '10px',
            cursor: 'grab',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: pieceConfig.border,
            backgroundColor:  cellInfo.status2 ? '#E89F1750'  : cellInfo.status1 ? 'rgba(183, 61, 61, 0.30)'  : 'rgba(89, 151, 92, 0.30)',
          };
        }      
      } else {
        style = {
          opacity: isDragging ? 0.5 : 1,
          width: pieceConfig.width,
          height: pieceConfig.height,
          marginBottom: '10px',
          cursor: 'grab',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: pieceConfig.border,
          backgroundColor:  pieceConfig.backgroundColor || pieceConfig.color || '#fff0',
        };
      }
    
      return (
        <div className="piece-box">
          <div ref={drag} onClick={() => type == 'rack' ? onPieceClick(cellInfo) : ""} className="piece" style={style}>
            {pieceConfig.img ? (
              <img
                src={pieceConfig.img}
                alt={pieceConfig.name}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain', // Ajusta a imagem ao tamanho do componente
                }}
              />
            ) : (
                <p>
                  {/* {temVirgula(cellInfo.label) ? cellInfo.label.split('/')[0] : cellInfo.label } */}
                </p>                     
            )}
          </div>
          <p>{temVirgula(cellInfo.label) ? cellInfo.label.split('/')[0] : cellInfo.label }</p>
        </div>
        
      );
  };